/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3);
	__webpack_require__(5);
	
	var pageConfig = window.pageConfig;
	var validate = pageConfig.validate;
	var myProjectList = pageConfig.projectList;
	var util = __webpack_require__(7);
	var loadData = util.loadData;
	var i18n = __webpack_require__(8);
	var projectDetail = __webpack_require__(13);
	var projectInfo = __webpack_require__(34);
	var deliveryManagement = __webpack_require__(35);
	var userItem = __webpack_require__(36);
	var userList = __webpack_require__(37);
	var addProjectLayer = __webpack_require__(38);
	var cloneProject = __webpack_require__(40);
	var addUserLayer = __webpack_require__(42);
	var indexTPL = __webpack_require__(44);
	
	var currentProjectUsers;
	var roleMap = pageConfig.roleMap;
	var localUser = {
	  id: parseInt(decodeURIComponent(util.getCookie('uid') || ''), 10)
	};
	
	// Set nav title selected
	$('header div.nav a.my-project').addClass('selected');
	
	function getRoleList(role) {
	  var ret = [];
	  var self = roleMap[role];
	
	  for (var i in roleMap) {
	    if (roleMap[i] >= self) {
	      ret.push(i);
	    }
	  }
	  return ret;
	}
	
	function showDelBtn(role) {
	  return localUser.isCreator || !(roleMap[localUser.role] > roleMap['master'] || roleMap[localUser.role] >= roleMap[role]);
	}
	
	function changeUserRole(value, text) {
	  var list = $('.project-list');
	  var pid = list.find('.selected').data('project-id');
	  var user = $(this).data('user');
	  var role = value;
	  var td = $(this).closest('td');
	  var row = $(this).closest('tr');
	
	  loadData('/project/' + pid + '/changeUserRole/' + user, {
	    role: role
	  }, 'POST', function (res) {
	    if (role == localUser.role) {
	      td.html(role);
	      row.find('td:last .del-user').hide();
	      return;
	    }
	
	    var btn = '<button data-user="' + user + '" class="ui button del-user" >' + i18n('common.remove') + '</button>';
	    var showBtn = showDelBtn(role);
	
	    if (showBtn) {
	      //change user role event
	      if (row.find('td:last .del-user').length) {
	        row.find('td:last .del-user').show();
	      } else {
	        row.find('td:last').append(btn);
	      }
	    } else {
	      row.find('td:last .del-user').hide();
	    }
	  });
	}
	
	function updateProjectField($inp) {
	  var $field = $inp.parent();
	  var projectId = $('.project-info .project-id').text().trim();
	  var name = $field.attr('name');
	  var value = $inp.val().trim();
	  if (name === 'name') {
	    if (!value || /^test/.test(value) || value.length > validate.maxProjectName || value.length < validate.minProjectName) {
	      $field.html($field.data('lastContent'));
	      return;
	    }
	  }
	  if (name === 'desc' && value.length > validate.maxDescription) {
	    $field.html($field.data('lastContent'));
	    return;
	  }
	
	  if (value === $field.data('lastContent')) {
	    $field.html(value);
	    return;
	  }
	  loadData('/project/ ' + projectId + '/updateField', {
	    field: name,
	    value: value
	  }, 'POST', function (res) {
	    //if (name === 'name' || name === 'description') {
	    value = value.replace(/</g, '&lt;');
	    //}
	    $field.html(value);
	    if (name === 'name') {
	      $('.project-list li[data-project-id=' + projectId + ']').html(value);
	    }
	  });
	}
	
	var App = {
	  init: function init() {
	    if (pageConfig.error) {
	      util.show({
	        icon: 'error',
	        content: pageConfig.error
	      });
	      return;
	    }
	
	    var list = myProjectList.projects;
	    var delList = myProjectList.deletedProjects;
	    var indexHTML = indexTPL({
	      projectList: list,
	      deletedProjectList: delList,
	      i18n: i18n()
	    });
	    $(indexHTML).appendTo($('body'));
	
	    var list = $('.project-list');
	    list.on('click', 'li:not(.selected)', function (e) {
	      var target = $(e.target);
	      var pid = target.data('project-id');
	
	      pid && loadData('/project/' + pid, {}, function (res) {
	        var data = res.data;
	        if (data) {
	          data = handleProjectInfo(data, pid);
	          data.pid = pid;
	          var html = projectDetail(data);
	          $('.project-detail').html(html);
	
	          list.find('.selected').removeClass('selected');
	          target.addClass('selected');
	
	          html = projectInfo(data);
	          $('.project-wrap').html(html);
	        } else {
	          target.hide();
	        }
	      });
	
	      try {
	        localStorage.pid = pid;
	      } catch (e) {}
	    });
	
	    $('body').on('click', '.add-project', function () {
	      $('.add-project-layer').modal('show');
	    });
	
	    function onAddProject(data) {
	      data.name = data.name.replace(/</, '&lt;');
	      var $item = $('<li class="elli" data-project-id="' + data.id + '">' + data.name + '</li>');
	      $item.prependTo($('.project-list'));
	
	      var empty = $('.add-my-first-project');
	
	      if (empty.length) {
	        empty.remove();
	        $('.wrapper').css('display', 'table');
	      }
	
	      $item.click();
	    }
	    addProjectLayer(onAddProject);
	
	    cloneProject(onAddProject);
	
	    function handleProjectInfo(data, pid) {
	
	      data.time_created = util.format(data.time_created);
	      data.workbenchUrl = location.protocol + '//workbench.enhancer.' + location.hostname.match(/\w+$/) + '/proj/' + pid;
	
	      var found = 0;
	      var user;
	      localUser.isCreator = data.creator === localUser.id;
	      data.showPublic = localUser.isCreator;
	      data.is_public = data.is_public === 'Y' && localUser.isCreator;
	      data.users.some(function (item) {
	        if (item.id == localUser.id) {
	          localUser.role = item.role;
	          data.showBtn = roleMap[item.role] < roleMap['master']; // 只有 owner才能删除成员, 只有creator 才能删 owner
	          data.showEditable = roleMap[item.role] <= roleMap['master']; //  只有owner和master才能编辑标题和描述
	          data.showClone = roleMap[item.role] <= roleMap['master']; //  只有owner和master才能克隆项目
	          found++;
	        }
	        if (item.id === data.creator) {
	          user = item;
	          found++;
	        }
	        return found > 1;
	      });
	      data.role = localUser.role;
	      data.nickname = user.nickname;
	      currentProjectUsers = data.users;
	      data.delText = i18n(localUser.id === data.creator ? 'delete' : 'leave');
	      return data;
	    }
	
	    $('.project-detail').on('click', '.project-tabs > li:not(.selected)', function (e) {
	      var target = $(e.target).closest('li');
	      var tab = target.data('tab');
	      var pid = list.find('.selected').data('project-id');
	      var html;
	
	      function changeTab() {
	        $('.project-tabs .selected').removeClass('selected');
	        target.addClass('selected');
	      }
	
	      switch (tab) {
	        case 'project-info':
	          loadData('/project/' + pid, {}, function (res) {
	            if (res.data) {
	              var data = handleProjectInfo(res.data, pid);
	              html = projectInfo(data);
	              $('.project-wrap').html(html);
	              changeTab();
	            } else {
	              target.hide();
	            }
	          });
	          break;
	        case 'delivery-management':
	          html = deliveryManagement({
	            deliveryUrl: '//delivery.enhancer.' + location.hostname.match(/\w+$/) + '/proj/' + pid + '/release/home'
	          });
	          $('.project-wrap').html(html);
	          changeTab();
	          break;
	        case 'authorization':
	          loadData('/project/' + pid + '/users/', {}, function (res) {
	            res.data.forEach(function (item) {
	              var itemRole = roleMap[item.role];
	              var userRole = roleMap[localUser.role];
	              if (item.user_id == localUser.id || userRole > roleMap['master'] || userRole > itemRole || userRole == itemRole && !localUser.isCreator) {
	                item.showList = false;
	              } else {
	                item.showList = true;
	                item.roleList = getRoleList(localUser.role, item.role);
	              }
	              var user;
	              currentProjectUsers.some(function (it) {
	                if (it.id === item.user_id) {
	                  user = it;
	                  return true;
	                }
	              });
	
	              if (user) {
	                item.nickname = user.nickname;
	                item.avatar = user.avatar;
	              }
	            });
	
	            res.showAddUser = roleMap[localUser.role] <= roleMap['master']; // master 和 owner 都能添加成员  
	            html = userList(res);
	            $('.project-wrap').html(html);
	            changeTab();
	
	            $('.project-wrap .dropdown').dropdown({
	              onChange: changeUserRole
	            });
	          });
	          break;
	      }
	    });
	
	    // Grant
	    $('.project-detail').on('click', 'a.button.grant-project', function () {
	      $(this).parent().parent().parent().prev().find('li[data-tab=authorization]').click();
	    });
	
	    // Public
	    $('.project-detail').on('click', 'a.button.public-project', function () {
	      var self = this;
	      var pid = $(this).attr('data-project-id');
	      var open = $(this).find('.icon').hasClass('unlock');
	
	      util.showConfirm(i18n('home.confirm.' + (open ? 'un' : '') + 'public.project'), function () {
	        loadData('/project/' + pid + '/public', {
	          is_public: !open
	        }, 'POST', function (res) {
	          $(self).find('.icon').toggleClass('unlock');
	          $(self).find('span').text(i18n((open ? '' : 'un') + 'public.project'));
	        });
	      }, function () {});
	    });
	
	    // Delete
	    $('.project-detail').on('click', '.button.delete-project', function (e) {
	      var pid = $(this).attr('data-project-id');
	      var creator = $(this).attr('data-creator');
	      var tip = creator == localUser.id ? 'home.confirm.remove.project' : 'tip.exit';
	
	      util.showConfirm(i18n(tip), function () {
	        loadData('/project/' + pid + '/delete', {}, 'POST', function (res) {
	          window.location.reload();
	        });
	      }, function () {});
	    });
	
	    // Clone
	    $('.project-detail').on('click', '.button.clone-project', function (e) {
	      var pid = $(this).attr('data-project-id');
	      var pname = $(this).attr('data-project-name');
	      util.showConfirm(i18n('home.clone.tip'), function () {
	        var layer = $('.clone-project-layer');
	
	        layer.find('input[name=name]').val('New ' + pname);
	        layer.find('input[name=desc]').val('Cloned From ' + pname);
	        layer.data('pid', pid).data('pname', pname);
	        layer.modal('show');
	      }, null, i18n('home.sure'));
	    });
	
	    $('body').on('click', '.del-project-list-title', function () {
	      if ($(this).hasClass('expended')) {
	        $(this).removeClass('expended').find('i.caret').removeClass('down').addClass('left');
	        $(this).next().hide('blind');
	      } else {
	        $(this).addClass('expended').find('i.caret').addClass('down').removeClass('left');
	        $(this).next().show('blind');
	      }
	    });
	
	    addUserLayer(function (data) {
	      data.showBtn = showDelBtn(data.role);
	      $('.project-wrap .developer-list tbody').prepend(userItem(data));
	
	      $('.project-wrap .developer-list tr').eq(1).find('.dropdown').dropdown({
	        onChange: changeUserRole
	      });
	    });
	
	    $('body').on('click', '.add-user', function () {
	      $('.add-user-layer .dropdown.role .menu .item[data-value=owner]').toggle(localUser.role === 'owner');
	      $('.add-user-layer').modal('show');
	    });
	    $('body').on('click', '.project-wrap .del-user', function () {
	      var uid = $(this).data('user');
	      var pid = list.find('.selected').data('project-id');
	      var row = $(this).closest('tr');
	
	      util.showConfirm(i18n('home.confirm.remove.user'), function () {
	        loadData('/project/' + pid + '/delUser/' + uid, {}, 'POST', function (res) {
	          row.remove();
	        });
	      }, function () {});
	    });
	
	    $('body').on('click', '.project-wrap span.editable', function (e) {
	      var $this = $(this);
	      var lastContent = $this.text().trim();
	      $this.data('lastContent', lastContent);
	      var $inp = $('<input>').val(lastContent).on('click', function (e) {
	        e.stopPropagation();
	      }).on('keyup', function (e) {
	        if (e.keyCode === 13) {
	          updateProjectField($(this));
	        }
	      }).on('blur', function (e) {
	        updateProjectField($(this));
	      });
	
	      $this.html('').append($inp);
	      $inp.focus();
	    });
	
	    // Undelete
	    $('body').on('click', 'i.undelete', function (e) {
	      var pid = $(this).closest('li').attr('data-project-id');
	      loadData('/project/' + pid + '/undelete', {}, 'POST', function (res) {
	        window.location.reload();
	      });
	    });
	
	    // Delete permanent
	    $('body').on('click', 'i.delete-permanent', function (e) {
	      var pid = $(this).closest('li').attr('data-project-id');
	      var pname = $(this).closest('li').find('.deleted-name').html().trim();
	      var tips = i18n('removePermanent', {
	        name: pname
	      });
	      util.showConfirm(tips, function () {
	        loadData('/project/' + pid + '/delete', {
	          permanent: true
	        }, 'POST', function (res) {
	          window.location.reload();
	        });
	      }, function () {});
	    });
	
	    var empty = '<div class="button add-my-first-project add-project">' + '<i class="plus icon "></i>' + i18n('home.add.first.project') + '</div>';
	
	    $('body').append(empty);
	
	    if (list.find('li').length) {
	      var projectId;
	      try {
	        projectId = localStorage.pid;
	      } catch (e) {};
	
	      var li = list.find('li[data-project-id=' + projectId + ']');
	      if (li.length) {
	        li.click();
	      } else {
	        list.find('li:first').click();
	      }
	    } else {
	      $('.wrapper').css('display', 'none');
	      $('.add-my-first-project').css('display', 'block');
	    }
	
	    if (location.hash) {
	      var match = location.hash.match(/project=(\d+)/);
	      if (match) {
	        $('.project-list li[data-project-id=' + match[1] + ']').click();
	      }
	    }
	  }
	};
	
	// Entry
	(function () {
	  App.init();
	})();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var track = __webpack_require__(6);
	track('project-center-assets');

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	var initError = false;
	var sumitting = false;
	var interval = 2000;
	function reset() {
		setTimeout(function () {
			sumitting = false;
			interval += 2000;
		}, window.enhancerErrorInterval || interval);
	}
	function getCookie(name) {
		var cookieStr;
		var cookies = document.cookie.split(";");
	
		for (var i = 0; i < cookies.length; i++) {
			cookieStr = cookies[i].split("=");
			if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
				return decodeURI(cookieStr[1]);
			}
		}
	}
	var oldError = window.onerror;
	
	try {
		var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
		var month = 30 * 24 * 3600 * 1000;
		Object.keys(errorData).forEach(function (key) {
			var item = errorData[key];
			if (Date.now() - item.time > month) {
				delete errorData[key];
			}
		});
		localStorage.setItem('errorData', JSON.stringify(errorData));
	} catch (err) {
		console.error(err);
	}
	
	function checkLow() {
		var agent = navigator.userAgent.toLowerCase();
		var ie = /(msie\s|trident.*rv:)([\w.]+)/i.test(agent);
	
		if (ie) {
			var v1 = agent.match(/(?:msie\s([\w.]+))/);
			var v2 = agent.match(/(?:trident.*rv:([\w.]+))/);
			var version;
			if (v1 && v2 && v1[1] && v2[1]) {
				version = Math.max(v1[1] * 1, v2[1] * 1);
			} else if (v1 && v1[1]) {
				version = v1[1] * 1;
			} else if (v2 && v2[1]) {
				version = v2[1] * 1;
			} else {
				version = 0;
			}
			return version < 11;
		} else {
			return false;
		}
	}
	
	module.exports = function (projectName, url, cb) {
		if (initError) {
			return;
		}
		initError = true;
		window.onerror = checkLow() ? function () {} : function (msg, uri, row, col, err) {
			if (msg.toLowerCase() === 'script error.' && !uri) {
				return;
			}
			col = typeof col === 'number' ? col : 0;
			uri = uri || window.location.href;
			var stack = err ? err.stack : '';
			var key = msg + uri + row + col;
	
			try {
				var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
				if (errorData[key] && errorData[key].stack === stack.toString()) {
					return;
				}
			} catch (err) {
				console.error(err);
			}
	
			try {
				if (sumitting) {
					return;
				}
				sumitting = true;
	
				var submitData = {
					project: projectName,
					msg: msg,
					uri: uri,
					row: row,
					uid: getCookie('uid') || '',
					col: col,
					ua: window.navigator.userAgent,
					stack: stack
				};
				$.ajax({
					url: url || '/tool/error',
					type: 'POST',
					data: submitData
				}).done(function (res) {
					reset();
					try {
						var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
						errorData[key] = {
							time: Date.now(),
							stack: stack.toString()
						};
						localStorage.setItem('errorData', JSON.stringify(errorData));
					} catch (err) {
						console.error(err);
					}
				}).fail(function () {
					reset();
					console.log(arguments);
				});
	
				if (oldError) {
					oldError.call(window, msg, uri, row, col, err);
				}
				cb && cb(submitData);
			} catch (err) {
				console.log(err);
				reset();
			}
		};
	
		window.addEventListener('error', function (e) {
			var error = e.error;
			if (error) {
				var msg = error.message || e.message || '';
				if (msg.toLowerCase() === 'script error.' && !e.filename && !error.filename) {
					return;
				}
				window.onerror(msg, e.filename, e.lineno, e.colno, error);
			} else {
				var stack = e.target.outerHTML || e.message;
				if (stack.indexOf('hm.baidu.com') === -1) {
					if (!e.message && e.target.outerHTML) {
						stack += ' ---- ';
						var node = e.target.parentNode;
						while (node && node.tagName) {
							stack += '-> ' + node.tagName + '(' + (node.className || node.id || node.src || node.href || '') + ')';
							node = node.parentNode;
						}
					}
					if (e.filename) {
						window.onerror(e.message || 'network error', e.filename, e.lineno || -1, e.colno || -1, { stack: stack });
					}
				}
			}
		}, true);
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var i18n = __webpack_require__(8);
	var pop = __webpack_require__(10);
	var ajax = __webpack_require__(12);
	
	var util = {};
	
	util.makeZero = function (num) {
	  return num < 10 ? '0' + num : num;
	};
	
	util.format = function (time) {
	  var date = new Date(time);
	  return date.getFullYear() + '-' + util.makeZero(date.getMonth() + 1) + '-' + util.makeZero(date.getDate()) + ' ' + util.makeZero(date.getHours()) + ':' + util.makeZero(date.getMinutes()) + ':' + util.makeZero(date.getSeconds());
	};
	
	util.getCookie = function (name) {
	  var i,
	      cookie,
	      cookieStr,
	      cookies = document.cookie.split(";");
	
	  for (i = 0; i < cookies.length; i++) {
	    cookie = cookies[i];
	    cookieStr = cookie.split("=");
	    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
	      return decodeURI(cookieStr[1]);
	    }
	  }
	};
	
	util.setCookie = function (name, value, expire, domain, path, secure) {
	  var date,
	      str = escape(name) + "=" + escape(value);
	  date = new Date();
	
	  date.setTime(date.getTime() + expire);
	  str += domain ? "; domain=" + domain : "";
	  str += path ? "; path=" + path : "";
	  str += expire ? "; expires=" + date.toGMTString() : "";
	  str += secure ? "; secure" : "";
	  document.cookie = str;
	};
	
	util.loadData = function () {
	  var loading = {};
	  return function (url, data, type, success, ui, fail) {
	    if (typeof type == 'function') {
	      fail = ui;
	      ui = success;
	      success = type;
	      type = 'GET';
	    }
	
	    if (loading[url]) {
	      return;
	    }
	    loading[url] = 1;
	    ui && ui.addClass('loading');
	
	    var opt = {
	      type: type,
	      url: url,
	      data: data
	    };
	    if (type === 'POST') {
	      opt.data = JSON.stringify(data);
	      opt.contentType = 'application/json';
	      opt.dataType = 'json';
	    }
	    //start loading
	    opt.beforeSend = function (xhr) {
	      xhr.setRequestHeader("CSRF-Token", $('#csrfToken').val());
	    };
	    ajax(opt, function (res) {
	      if (loading[url]) {
	        delete loading[url];
	        ui && ui.removeClass('loading');
	        if ((typeof res === 'undefined' ? 'undefined' : _typeof(res)) != 'object') {
	          return util.show({
	            icon: 'warning',
	            content: 'not login'
	          });
	        }
	        if (res.success) {
	          return success(res);
	        }
	        util.show({
	          icon: 'error',
	          content: res.message || 'failed to load data'
	        });
	        fail && fail();
	      }
	    }, function () {
	      util.show({
	        icon: 'error',
	        content: 'failed to load data'
	      });
	      ui && ui.removeClass('loading');
	      delete loading[url];
	      fail && fail();
	    });
	  };
	}();
	
	util.showConfirm = function (msg, confirm, deny, confirmText) {
	  var footer = {};
	  footer[confirmText || i18n('common.confirm')] = confirm;
	  util.show({
	    title: i18n('common.tip'),
	    close: true,
	    width: 300,
	    content: msg,
	    footer: footer,
	    onHide: function onHide(from) {
	      if (from === 'close') {
	        deny && deny();
	      }
	    }
	  });
	};
	
	util.show = function (opt) {
	  pop.show(opt);
	};
	util.hide = function () {
	  pop.hide();
	};
	
	module.exports = util;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// LANG is a macro defined in webpack.config.js
	
	var locale = __webpack_require__(9);
	var __lang__ = '__lang__';
	
	module.exports = function (key, options) {
	    if (!key) {
	        return locale;
	    }
	
	    if (__lang__ === key) {
	        return ('en');
	    }
	
	    options = options || {};
	
	    return locale[key] ? locale[key].replace(/\{\{(\w+)\}\}/g, function (s, $1) {
	        return options[$1];
	    }) : function () {
	
	        console.warn('Key ' + key + ' is not found in locale');
	        return '<?No Translation>';
	    }();
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    "global.project.center": "Project Center",
	    "nav.samples": "Samples",
	    "nav.tutorial": "Tutorial",
	    "common.confirm": "Confirm",
	    "common.cancel": "Cancel",
	    "common.remove": "Remove",
	    "common.operation": "Operation",
	    "common.tip": "Tip",
	    "common.role": "Role",
	    "common.creator": "Creator",
	    "common.project": "Project",
	    "common.creation.time": "Creation Time",
	    "common.developer": "Developer",
	    "home.no.project.click": "Project list is empty, please click",
	    "home.add.project": "Add Project",
	    "home.add.first.project": "Add My First Project",
	    "home.confirm.remove.user": "Confirm removing user ?",
	    "home.project.name": "Poject Name",
	    "home.project.description": "Poject Description",
	    "home.add.user": "Add User",
	    "home.username": "Username",
	    "home.project.detail": "Project Detail",
	    "home.release.management": "Release Management",
	    "home.development.authorization": "Development Authorization",
	    "home.enter.workbench": "Enter workbench",
	    "home.my.role": "My Role",
	    "home.developer.list": "Developer List",
	    "home.add.member": "Add Member",
	    "home.project.public": "Public",
	    "tip.input.project.name": "Please input project name",
	    "tip.project.name.length": "The project name should be {{min}}-{{max}} characters",
	    "tip.project.description.length": "The project description cannot exceed {{max}} characters",
	    "tip.input.username": "Please input username",
	    "tip.select.role": "Please select a role",
	    "tip.no.results": "No results found",
	    "delete": "Delete",
	    "home.confirm.remove.project": "Are you sure to delete this project?",
	    "myProject": "My Project",
	    "deletedProject": "Deleted Project",
	    "cloneProject": 'Clone Project',
	    "grant": "Grant",
	    "cloneInfo": "Clone Info",
	    "clonedFrom": "Cloned From",
	    "number": "Number",
	    "removePermanent": "Are you sure to delete {{name}} permanently ?",
	    "startWithTest": "The project name can't start with test",
	    "leave": "leave project",
	    "tip.exit": "Are you sure to leave this project ?",
	    "public.project": "Public",
	    "unpublic.project": "Private",
	    "home.confirm.unpublic.project": "Are you sure to make project public ?",
	    "home.confirm.public.project": "Are you sure to make project private ?",
	    "home.sure": "Sure",
	    "home.clone.tip": "Note: You need to open all pages in cloned project's workbench to confirm each page fees, otherwise the project can't be published.",
	    "wait.project.clone": "Cloning project, please wait...",
	    "pri.detail": "Privilege Detail",
	    "view.info": "View Project Info",
	    "del.project": "Delete Project",
	    "release.project": "Release Project",
	    "add.project.user": "Add Project Member",
	    "change.role": "Change Member Role",
	    "del.member": "Remove Member",
	    "view.workbench": "View Workbench",
	    "edit.workbench": "Edit Workbench",
	    "pri.note": "Note: everyone can view workbench in public project, but cannot edit workbench"
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(11);
	
	var continer = $('<div class="enhancer-fe-pop"></div>');
	$('body').append(continer);
	
	var pop = {
		show: function show(opt) {
			opt = opt || {};
			var option = $.extend(true, {
				mask: true,
				icon: '',
				close: false,
				title: '',
				content: 'content',
				timeout: 2500,
				autoClose: true
			}, opt || {});
	
			if (!option.footer && !('mask' in opt)) {
				option.mask = false;
			}
	
			var mask = option.mask ? '<div class="fe-pop-mask"></div>' : '';
			var close = option.close ? '<div class="fe-pop-close">&times</div>' : '';
			var icon = option.icon ? '<div class="fe-pop-icon pop-' + option.icon + '"></div>' : '';
			var title = option.title ? '<div class="fe-pop-title">' + option.title + '</div>' : '';
			var footer = option.footer ? '<div class="fe-pop-footer">\n\t\t\t\t\t\t' + Object.keys(option.footer).map(function (key) {
				return '<button class="enhancer-btn" data-callback="' + key + '">' + key + '</button>';
			}) + '\n\t\t\t\t\t</div>' : '';
	
			var html = mask + '\n\t\t\t<div class="fe-pop-wrap">\n\t\t\t\t' + close + '\n\t\t\t\t<div class="fe-pop-content-wrap">\n\t\t\t\t\t' + icon + '\n\t\t\t\t\t<div style="flex: 1;">\n\t\t\t\t\t\t' + title + '\n\t\t\t\t\t\t<div class="fe-pop-content ' + (footer ? 'fe-indent' : '') + '">' + option.content + '</div>\n\t\t\t\t\t\t' + footer + '\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t';
	
			continer.html(html).show();
			continer.off('click');
			continer.on('click', '.fe-pop-close', function (e) {
				pop.hide('close');
			});
			continer.on('click', '.fe-pop-footer button', function (e) {
				var key = $(e.target).data('callback');
				var callbak = option.footer[key];
				if (callbak && typeof callbak === 'function') {
					callbak.call(e.target, e);
					if (option.autoClose) {
						pop.hide('footer.' + key);
					}
				}
			});
	
			if (!option.footer && option.timeout) {
				setTimeout(function () {
					pop.hide('timeout');
				}, option.timeout);
			}
			this.option = option;
			if (opt.width) {
				continer.find('.fe-pop-wrap').width(opt.width);
			}
		},
		hide: function hide(from) {
			continer.hide();
			var onHide = this.option.onHide;
	
			if (onHide && typeof onHide === 'function') {
				onHide(from);
			}
		}
	};
	
	module.exports = pop;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (option, success, fail) {
	  var data = option.data || {};
	  var url = option.url;
	
	  if (data.password) {
	    data = JSON.parse(JSON.stringify(data));
	    delete data.password;
	  }
	
	  $.ajax(option).done(function (ret) {
	    success.call(this, ret);
	  }).fail(function (err, status, message) {
	    fail && fail(err, status, message);
	    data.ajaxStatus = status;
	    data.ajaxMessage = message;
	    if (err) {
	      data.ajaxCode = err.status + ': ' + (err.statusText || '');
	    }
	
	    window.onerror(status + ': ' + message, url, -1, -1, {
	      stack: JSON.stringify(data)
	    });
	  });
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;
	
	  return "<ul class=\"project-tabs clearfix\">\n    <li data-tab=\"project-info\" class=\"selected\">\n        <i class=\"info circle icon\"></i>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.detail",{"name":"i18n","hash":{},"data":data}))
	    + "\n    </li>\n    <li data-tab=\"delivery-management\"><i class=\"list icon\"></i>"
	    + alias2(__webpack_require__(33).call(alias1,"home.release.management",{"name":"i18n","hash":{},"data":data}))
	    + "</li>\n    <li data-tab=\"authorization\"><i class=\"users icon\"></i>"
	    + alias2(__webpack_require__(33).call(alias1,"home.development.authorization",{"name":"i18n","hash":{},"data":data}))
	    + "</li>\n</ul>\n\n<div class=\"project-wrap\">\n</div>\n";
	},"useData":true});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(15)['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj['default'] = obj;return newObj;
	  }
	}
	
	var _handlebarsBase = __webpack_require__(16);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(30);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(18);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(17);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(31);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(32);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _utils = __webpack_require__(17);
	
	var _exception = __webpack_require__(18);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(19);
	
	var _decorators = __webpack_require__(27);
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var VERSION = '4.0.11';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;
	
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function isFunction(value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  try {
	    if (loc) {
	      this.lineNumber = line;
	
	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (Object.defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _helpersBlockHelperMissing = __webpack_require__(20);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(21);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(22);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(23);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(24);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(25);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(26);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(17);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _utils = __webpack_require__(17);
	
	var _exception = __webpack_require__(18);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && (typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;
	
	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _exception = __webpack_require__(18);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(17);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(17);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _decoratorsInline = __webpack_require__(28);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(17);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function ret(context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(17);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj['default'] = obj;return newObj;
	  }
	}
	
	var _utils = __webpack_require__(17);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(18);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(16);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + (typeof templateSpec === 'undefined' ? 'undefined' : _typeof(templateSpec)));
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: Object.seal({}),
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);
	
	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(8);
	module.exports = function (key) {
	    return i18n(key);
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "editable";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "            "
	    + alias1(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"clonedFrom",{"name":"i18n","hash":{},"data":data}))
	    + "["
	    + alias1(alias2((depth0 != null ? depth0.clone_project_id : depth0), depth0))
	    + "]["
	    + ((stack1 = alias2((depth0 != null ? depth0.clone_project_name : depth0), depth0)) != null ? stack1 : "")
	    + "]\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "              <div class=\"item elli\">\n                <img class=\"ui avatar image\" src=\""
	    + alias2(alias1((depth0 != null ? depth0.avatar : depth0), depth0))
	    + "\">\n                <div class=\"content\">\n                  <div class=\"header\">"
	    + alias2(alias1((depth0 != null ? depth0.nickname : depth0), depth0))
	    + "</div>\n                  <a title=\""
	    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.contact : depth0), depth0))
	    + "</a>\n                </div>\n              </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "      <a class=\"button clone-project\" data-project-id="
	    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + " data-project-name=\""
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "\">\n        <i class=\"icon copy\"></i>"
	    + alias2(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"cloneProject",{"name":"i18n","hash":{},"data":data}))
	    + "\n      </a>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.is_public : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "");
	},"10":function(container,depth0,helpers,partials,data) {
	    var alias1=container.escapeExpression;
	
	  return "          <a class=\"button public-project\" data-project-id="
	    + alias1(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
	    + ">\n            <i class=\"lock unlock icon\"></i><span>"
	    + alias1(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"unpublic.project",{"name":"i18n","hash":{},"data":data}))
	    + "</span>\n          </a>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var alias1=container.escapeExpression;
	
	  return "          <a class=\"button public-project\" data-project-id="
	    + alias1(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
	    + ">\n            <i class=\"lock icon\"></i><span>"
	    + alias1(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"public.project",{"name":"i18n","hash":{},"data":data}))
	    + "</span>\n          </a>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, alias4=helpers.blockHelperMissing;
	
	  return "<div class=\"ui items project-info\">\n    <div class=\"item\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.project",{"name":"i18n","hash":{},"data":data}))
	    + " ID: </span>\n        <span class=\"description project-id\">"
	    + alias2(alias3((depth0 != null ? depth0.id : depth0), depth0))
	    + "</span>\n      </div>\n    </div>\n    <div class=\"item\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.name",{"name":"i18n","hash":{},"data":data}))
	    + ": </span>\n        <span class=\"description "
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.showEditable : depth0), depth0),{"name":"showEditable","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" name=\"name\" maxlen=\"40\">"
	    + ((stack1 = alias3((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
	    + "</span>\n      </div>\n    </div>\n    <div class=\"item\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.creator",{"name":"i18n","hash":{},"data":data}))
	    + ": </span>\n        <span class=\"description\" title=\""
	    + alias2(alias3((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\">"
	    + alias2(alias3((depth0 != null ? depth0.nickname : depth0), depth0))
	    + "</span>\n      </div>\n    </div>\n    <div class=\"item\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.creation.time",{"name":"i18n","hash":{},"data":data}))
	    + ": </span>\n        <span class=\"description\">"
	    + alias2(alias3((depth0 != null ? depth0.time_created : depth0), depth0))
	    + "</span>\n      </div>\n    </div>\n    <div class=\"item\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"home.my.role",{"name":"i18n","hash":{},"data":data}))
	    + ": </span>\n        <span class=\"description\">"
	    + alias2(alias3((depth0 != null ? depth0.role : depth0), depth0))
	    + "</span>\n      </div>\n    </div>\n    <div class=\"item multi-line\">\n      <div class=\"content\">\n        <span class=\"ui header\">\n          "
	    + alias2(__webpack_require__(33).call(alias1,"home.project.description",{"name":"i18n","hash":{},"data":data}))
	    + ": \n        </span>\n        <span class=\"description "
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.showEditable : depth0), depth0),{"name":"showEditable","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" name=\"description\" maxlen=\"256\">\n          "
	    + ((stack1 = alias3((depth0 != null ? depth0.description : depth0), depth0)) != null ? stack1 : "")
	    + "\n        </span>\n      </div>\n    </div>\n    <div class=\"item multi-line\">\n      <div class=\"content\">\n        <span class=\"ui header\">\n          "
	    + alias2(__webpack_require__(33).call(alias1,"cloneInfo",{"name":"i18n","hash":{},"data":data}))
	    + ": \n        </span>\n        <span class=\"description\" name=\"cloneInfo\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.clone_project_id : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </span>\n      </div>\n    </div>\n    <div class=\"item multi-line\">\n      <div class=\"content\">\n        <span class=\"ui header\">"
	    + alias2(__webpack_require__(33).call(alias1,"home.developer.list",{"name":"i18n","hash":{},"data":data}))
	    + ": </span>\n        <span class=\"description\">\n          <div class=\"ui relaxed horizontal list\">\n"
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.users : depth0), depth0),{"name":"users","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "          </div>\n        </span>\n      </div>\n    </div>\n    <div class=\"project-toolbar\">\n      <a class=\"button enter-workbench\" href=\""
	    + alias2(alias3((depth0 != null ? depth0.workbenchUrl : depth0), depth0))
	    + "\">\n        <i class=\"angle right icon\"></i>\n        "
	    + alias2(__webpack_require__(33).call(alias1,"home.enter.workbench",{"name":"i18n","hash":{},"data":data}))
	    + "\n        <i class=\"angle left icon\"></i>\n      </a>\n"
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.showClone : depth0), depth0),{"name":"showClone","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "      <a class=\"button grant-project\" data-project-id="
	    + alias2(alias3((depth0 != null ? depth0.id : depth0), depth0))
	    + ">\n        <i class=\"icon users\"></i>"
	    + alias2(__webpack_require__(33).call(alias1,"grant",{"name":"i18n","hash":{},"data":data}))
	    + "\n      </a>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPublic : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "      \n      <a class=\"button delete-project\" data-creator=\""
	    + alias2(alias3((depth0 != null ? depth0.creator : depth0), depth0))
	    + "\" data-project-id="
	    + alias2(alias3((depth0 != null ? depth0.id : depth0), depth0))
	    + " data-project-name=\""
	    + alias2(alias3((depth0 != null ? depth0.name : depth0), depth0))
	    + "\">\n        <i class=\"icon trash\"></i>"
	    + alias2(alias3((depth0 != null ? depth0.delText : depth0), depth0))
	    + "\n      </a>\n    </div>\n</div>\n";
	},"useData":true});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<iframe class=\"delivery-management\"\n	style=\"width: 1024px; border: none; height: 100%; overflow: auto\"\n	src=\""
	    + container.escapeExpression(((helper = (helper = helpers.deliveryUrl || (depth0 != null ? depth0.deliveryUrl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"deliveryUrl","hash":{},"data":data}) : helper)))
	    + "\">\n</iframe>";
	},"useData":true});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.escapeExpression;
	
	  return "      <button data-user=\""
	    + alias1(container.lambda((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\" class=\"button del-user\" >"
	    + alias1(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"common.remove",{"name":"i18n","hash":{},"data":data}))
	    + "</button>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<tr>\n  <td>"
	    + alias2(alias1((depth0 != null ? depth0.nickname : depth0), depth0))
	    + "</td>\n  <td>\n      <div class=\"ui dropdown\" data-user=\""
	    + alias2(alias1((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\">\n        <div class=\"text\">"
	    + alias2(alias1((depth0 != null ? depth0.role : depth0), depth0))
	    + "</div>\n        <i class=\"dropdown icon\"></i>\n        <div class=\"menu\">\n          <div class=\"item\">owner</div>\n          <div class=\"item\">master</div>\n          <div class=\"item\">developer</div>\n          <div class=\"item\">reporter</div>\n          </div>\n        </div>\n      </div>\n  </td>\n  <td>\n"
	    + ((stack1 = helpers.blockHelperMissing.call(depth0,alias1((depth0 != null ? depth0.showBtn : depth0), depth0),{"name":"showBtn","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "  </td>\n</tr>";
	},"useData":true});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "      <tr>\n        <td title=\""
	    + alias2(alias1((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.nickname : depth0), depth0))
	    + "</td>\n          <td>\n"
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.showList : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
	    + "          </td>\n        <td>\n"
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.showList : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </td>\n      </tr>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "            <div class=\"ui dropdown\" data-user=\""
	    + alias2(alias1((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\">\n              <div class=\"text\">"
	    + alias2(alias1((depth0 != null ? depth0.role : depth0), depth0))
	    + "</div>\n              <i class=\"dropdown icon\"></i>\n              <div class=\"menu\">\n"
	    + ((stack1 = helpers.blockHelperMissing.call(depth0,alias1((depth0 != null ? depth0.roleList : depth0), depth0),{"name":"roleList","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "              </div>\n              </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "                <div class=\"item\">"
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "</div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "              "
	    + container.escapeExpression(container.lambda((depth0 != null ? depth0.role : depth0), depth0))
	    + "\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var alias1=container.escapeExpression;
	
	  return "          <button data-user=\""
	    + alias1(container.lambda((depth0 != null ? depth0.user_id : depth0), depth0))
	    + "\" class=\"button mini del-user\" >"
	    + alias1(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"common.remove",{"name":"i18n","hash":{},"data":data}))
	    + "</button>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "  <div class=\"button add-user\">\n    <i class=\"plus icon\"></i> "
	    + container.escapeExpression(__webpack_require__(33).call(depth0 != null ? depth0 : (container.nullContext || {}),"home.add.member",{"name":"i18n","hash":{},"data":data}))
	    + "\n  </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, alias4=helpers.blockHelperMissing;
	
	  return "<div>\n  <table class=\"ui basic table developer-list\">\n    <thead>\n      <tr>\n        <th width=\"50%\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.developer",{"name":"i18n","hash":{},"data":data}))
	    + "</th>\n        <th width=\"30%\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.role",{"name":"i18n","hash":{},"data":data}))
	    + "</th>\n        <th width=\"20%\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.operation",{"name":"i18n","hash":{},"data":data}))
	    + "</th>\n      </tr>\n    </thead>\n    <tbody>\n"
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.data : depth0), depth0),{"name":"data","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </tbody>\n  </table>\n\n"
	    + ((stack1 = alias4.call(depth0,alias3((depth0 != null ? depth0.showAddUser : depth0), depth0),{"name":"showAddUser","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "  <h4>"
	    + alias2(__webpack_require__(33).call(alias1,"pri.detail",{"name":"i18n","hash":{},"data":data}))
	    + "</h4>\n  <table class=\"pri-table\">\n    <thead>\n      <tr>\n        <th></th>\n        <th>owner(creator)</th>\n        <th>owner</th>\n        <th>master</th>\n        <th>developer</th>\n        <th>reporter</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"view.info",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"cloneProject",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"public.project",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"del.project",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"release.project",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n        <td></td>\n      </tr>\n      <!--\n      <tr>\n        <td>查看项目成员</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n      </tr>\n    -->\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"add.project.user",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"change.role",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"del.member",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"view.workbench",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n      </tr>\n      <tr>\n        <td>"
	    + alias2(__webpack_require__(33).call(alias1,"edit.workbench",{"name":"i18n","hash":{},"data":data}))
	    + "</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td>√</td>\n        <td></td>\n      </tr>\n    </tbody>\n  </table>\n  <p style=\"margin-top: 10px;\">"
	    + alias2(__webpack_require__(33).call(alias1,"pri.note",{"name":"i18n","hash":{},"data":data}))
	    + "</p>\n</div>";
	},"useData":true});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var initialized = false;
	var pageConfig = window.pageConfig;
	var validate = pageConfig.validate;
	var i18n = __webpack_require__(8);
	var util = __webpack_require__(7);
	var addProjectLayer = __webpack_require__(39);
	$('body').append(addProjectLayer({}));
	
	$.fn.form.settings.rules.projectNameForbidTest = function (value) {
	  return !!value.indexOf('test');
	};
	
	module.exports = function (success) {
	  if (initialized) {
	    return;
	  }
	  initialized = true;
	  var layer = $('.add-project-layer');
	  layer.form({
	    inline: true,
	    on: 'blur',
	    fields: {
	      name: {
	        identifier: 'name',
	        rules: [{
	          type: 'empty',
	          prompt: i18n('tip.input.project.name')
	        }, {
	          type: 'maxLength[' + validate.maxProjectName + ']',
	          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
	        }, {
	          type: 'minLength[' + validate.minProjectName + ']',
	          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
	        }, {
	          type: 'projectNameForbidTest',
	          prompt: i18n('startWithTest')
	        }]
	      },
	      desc: {
	        identifier: 'desc',
	        rules: [{
	          type: 'maxLength[' + validate.maxDescription + ']',
	          prompt: i18n('tip.project.description.length', { max: validate.maxDescription })
	        }]
	      }
	    },
	    onSuccess: function onSuccess(e, data) {
	      data.is_public = !!data.is_public;
	      util.loadData('/project/add', data, 'POST', function (res) {
	        layer.find('.close').click();
	        success(res.data);
	      }, layer.find('.submit'));
	    }
	  });
	
	  layer.modal({
	    onHide: function onHide() {
	      layer.form('reset');
	    }
	  });
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;
	
	  return "<div class=\"ui modal small add-project-layer\">\n  <i class=\"close icon\"></i>\n  <div class=\"header\">\n    "
	    + alias2(__webpack_require__(33).call(alias1,"home.add.project",{"name":"i18n","hash":{},"data":data}))
	    + "\n  </div>\n  <div class=\"content\">\n    <div class=\"ui form\">\n      <div class=\"field inline\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.name",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <input type=\"text\" name=\"name\">\n      </div>\n      <div class=\"field inline\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.description",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <input type=\"text\" name=\"desc\">\n      </div>\n      <div class=\"field inline\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.public",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <div class=\"ui checkbox\" style=\"vertical-align: middle;\">\n          <input id=\"is_public\" type=\"checkbox\" name=\"is_public\">\n          <label for=\"is_public\"> </label>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"actions\">\n    <div class=\"ui button submit\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.confirm",{"name":"i18n","hash":{},"data":data}))
	    + "</div>\n  </div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var initialized = false;
	var pageConfig = window.pageConfig;
	var validate = pageConfig.validate;
	var i18n = __webpack_require__(8);
	var util = __webpack_require__(7);
	var cloneProjectLayer = __webpack_require__(41);
	$('body').append(cloneProjectLayer({}));
	
	$.fn.form.settings.rules.projectNameForbidTest = function (value) {
	  return !!value.indexOf('test');
	};
	
	module.exports = function (success) {
	  if (initialized) {
	    return;
	  }
	  initialized = true;
	  var layer = $('.clone-project-layer');
	  layer.form({
	    inline: true,
	    on: 'blur',
	    fields: {
	      name: {
	        identifier: 'name',
	        rules: [{
	          type: 'empty',
	          prompt: i18n('tip.input.project.name')
	        }, {
	          type: 'maxLength[' + validate.maxProjectName + ']',
	          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
	        }, {
	          type: 'minLength[' + validate.minProjectName + ']',
	          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
	        }, {
	          type: 'projectNameForbidTest',
	          prompt: i18n('startWithTest')
	        }]
	      },
	      desc: {
	        identifier: 'desc',
	        rules: [{
	          type: 'maxLength[' + validate.maxDescription + ']',
	          prompt: i18n('tip.project.description.length', { max: validate.maxDescription })
	        }]
	      }
	    },
	    onSuccess: function onSuccess(e, data) {
	      var pid = layer.data('pid');
	      data.cloneProjectName = layer.data('pname');
	      layer.find('.close').click();
	      // Add waiting animate...
	      var $loaderMask = $('<div>').addClass('loader-mask').css('height', $('body').height()).appendTo($('body'));
	
	      var $loader = $('<div>').addClass('loader').append('<div></div>').append('<span>' + i18n('wait.project.clone') + '</span>').appendTo($('body'));
	
	      util.loadData('/project/' + pid + '/clone', data, 'POST', function (res) {
	        success(res.data);
	        $loaderMask.fadeOut(600, function () {
	          $loaderMask.remove();
	        });
	        $loader.fadeOut(600, function () {
	          $loader.remove();
	        });
	      });
	    }
	  });
	
	  layer.find('.close').click(function () {
	    layer.modal('hide');
	  });
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;
	
	  return "<div class=\"ui modal small clone-project-layer\">\n  <i class=\"close icon\"></i>\n  <div class=\"header\">\n    "
	    + alias2(__webpack_require__(33).call(alias1,"cloneProject",{"name":"i18n","hash":{},"data":data}))
	    + "\n  </div>\n  <div class=\"content\">\n    <div class=\"ui form\">\n      <div class=\"field\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.name",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <input type=\"text\" name=\"name\">\n      </div>\n      <div class=\"field\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.project.description",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <input type=\"text\" name=\"desc\">\n      </div>\n    </div>\n  </div>\n  <div class=\"actions\">\n    <div class=\"ui button submit\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.confirm",{"name":"i18n","hash":{},"data":data}))
	    + "</div>\n  </div>\n</div>";
	},"useData":true});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var addValidate = false;
	var pageConfig = window.pageConfig;
	var i18n = __webpack_require__(8);
	var util = __webpack_require__(7);
	var addUserLayer = __webpack_require__(43);
	$('body').append(addUserLayer({
	  roles: Object.keys(pageConfig.roleMap || {})
	}));
	
	module.exports = function (success) {
	  if (addValidate) {
	    return;
	  }
	  addValidate = true;
	
	  var layer = $('.add-user-layer');
	  layer.form({
	    fields: {
	      uid: {
	        identifier: 'uid',
	        rules: [{
	          type: 'empty',
	          prompt: i18n('tip.input.username')
	        }]
	      },
	      role: {
	        identifier: 'role',
	        rules: [{
	          type: 'empty',
	          prompt: i18n('tip.select.role')
	        }]
	      }
	    },
	    onSuccess: function onSuccess(e, data) {
	      var pid = $('.project-list').find('.selected').data('project-id');
	      if (!pid) {
	        return;
	      }
	
	      util.loadData('/project/' + pid + '/addUser', data, 'POST', function (res) {
	        layer.find('.close').click();
	        res.data.nickname = currentSelectName;
	        success(res.data);
	      });
	    }
	  });
	
	  layer.find('.close').click(function () {
	    layer.find('input').val('');
	    layer.modal('hide');
	  });
	
	  var cache;
	  var currentSelectName;
	  layer.find('.ui.search').dropdown({
	    onChange: function onChange(value, text, select) {
	      currentSelectName = text;
	    },
	    apiSettings: {
	      url: 'queryUsers?key={value}&limit=10',
	      action: 'query users',
	      throttle: 500,
	      beforeSend: function beforeSend(settings) {
	        settings.urlData = {
	          value: layer.find('.ui.search .search').val()
	        };
	
	        return settings.urlData.value ? settings : false;
	      },
	      onResponse: function onResponse(res) {
	        var ret = {
	          results: []
	        };
	        if (!res.success) {
	          return cache || ret;
	        }
	
	        res.data.forEach(function (item) {
	          ret.results.push({
	            title: item.nickname,
	            name: item.nickname,
	            value: item.id,
	            uid: item.id
	          });
	        });
	        cache = ret;
	        return ret;
	      }
	    },
	    showOnFocus: false,
	    message: {
	      noResults: i18n('tip.no.results')
	    }
	  });
	
	  layer.find('.dropdown.role').dropdown({
	    onChange: function onChange(value, text) {}
	  });
	
	  layer.modal({
	    onHide: function onHide() {
	      layer.form('reset');
	    }
	  });
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "              <div class=\"item\" data-value=\""
	    + alias2(alias1(depth0, depth0))
	    + "\">"
	    + alias2(alias1(depth0, depth0))
	    + "</div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;
	
	  return "<div class=\"ui modal small add-user-layer\">\n  <i class=\"close icon\"></i>\n  <div class=\"header\">\n    "
	    + alias2(__webpack_require__(33).call(alias1,"home.add.user",{"name":"i18n","hash":{},"data":data}))
	    + "\n  </div>\n  <div class=\"content\">\n    <div class=\"ui form\">\n      <div class=\"field\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"home.username",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <div class=\"ui search selection dropdown\">\n            <input type=\"hidden\" name=\"uid\">\n            <i class=\"dropdown icon\"></i>\n            <input class=\"search\" type=\"text\" name=\"name\" autocomplete=\"off\"  tabindex=\"0\">\n            <div class=\"default text\">username</div>\n            <div class=\"menu\" tabindex=\"-1\"></div>\n        </div>\n      </div>\n      <div class=\"field\">\n        <label>"
	    + alias2(__webpack_require__(33).call(alias1,"common.role",{"name":"i18n","hash":{},"data":data}))
	    + "</label>\n        <div class=\"ui selection dropdown role\">\n          <input type=\"hidden\" name=\"role\">\n          <i class=\"dropdown icon\"></i>\n          <div class=\"default text\">role</div>\n          <div class=\"menu\">\n"
	    + ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? depth0.roles : depth0), depth0),{"name":"roles","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"actions\">\n    <div class=\"ui button submit\">"
	    + alias2(__webpack_require__(33).call(alias1,"common.confirm",{"name":"i18n","hash":{},"data":data}))
	    + "</div>\n  </div>\n</div>\n\n";
	},"useData":true});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(14);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda;
	
	  return "        <li data-project-id="
	    + container.escapeExpression(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + " class=\"elli\" title=\""
	    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
	    + "\">"
	    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
	    + "</li>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda;
	
	  return "        <li data-project-id="
	    + container.escapeExpression(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + " class=\"elli\" title=\""
	    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
	    + "\">\n          <span class=\"deleted-name\">"
	    + ((stack1 = alias1((depth0 != null ? depth0.name : depth0), depth0)) != null ? stack1 : "")
	    + "</span>\n          <span class=\"icon-bg\">\n            <i class=\"icon undo undelete\"></i>\n            <i class=\"icon trash delete-permanent\"></i>\n          </span>\n        </li>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=helpers.blockHelperMissing;
	
	  return "<div class=\"wrapper container clearfix\">\n  <div class=\"container-left\">\n    <div class=\"my-project-title\">\n      <i class=\"icon list\"></i>\n      <span>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.i18n : depth0)) != null ? stack1.myProject : stack1), depth0))
	    + "</span>\n      <i class=\"plus icon fr add-project\"></i>\n    </div>\n    <div class=\"project-list-wrap\">\n      <ul class=\"project-list\">\n"
	    + ((stack1 = alias3.call(depth0,alias1((depth0 != null ? depth0.projectList : depth0), depth0),{"name":"projectList","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "      </ul>\n      <div class=\"del-project-list-title\">\n        <i class=\"icon trash\"></i>\n        <span>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.i18n : depth0)) != null ? stack1.deletedProject : stack1), depth0))
	    + "</span>\n        <i class=\"icon caret left fr\"></i>\n      </div>\n      <ul class=\"deleted-project-list\">\n"
	    + ((stack1 = alias3.call(depth0,alias1((depth0 != null ? depth0.deletedProjectList : depth0), depth0),{"name":"deletedProjectList","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "      </ul>\n    </div>\n  </div>\n  <div class=\"container-right\">\n    <div class=\"project-detail\"></div>\n  </div>\n</div>";
	},"useData":true});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// home.js